import { useState, useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import ApiClient from '../common/ApiClient.js'
import useDebounced from './useDebounced'

const useAIProducts = ({ initialPageSize }) => {
  const { getAccessTokenSilently } = useAuth0()

  const [products, setProducts] = useState([])
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(initialPageSize || 10)
  const [count, setCount] = useState(0)
  const [isProductsLoading, setIsLoading] = useState(true)
  const [query, debouncedQuery, setQuery] = useDebounced('')

  useEffect(() => {
    setIsLoading(true)
    const getProducts = async () => {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      })
      await ApiClient.get(`/products?application=AI`, token)
        .then((response) => {
          setProducts(response.data.products)
          setCount(response.data.products.length)
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false)
        })
    }
    getProducts()
  }, [getAccessTokenSilently, page, pageSize, debouncedQuery])

  return {
    query,
    debouncedQuery,
    isProductsLoading,
    products,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (rowsPerPage) => setPageSize(rowsPerPage),
    count,
    page,
    pageSize,
    setQuery,
  }
}

export default useAIProducts
